import React from 'react';
import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import PropTypes from 'prop-types';

export class TopBar extends React.Component {
  render() {
    const { background, fixed } = this.props;
    return (
      <Bar background={background} fixed={fixed}>
        <BarContent>{this.props.children}</BarContent>
      </Bar>
    );
  }
}

const Bar = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  padding: ${props => props.theme.spacing.medium} 0;
  background: ${props => props.background};
  z-index: 2;
`;

const BarContent = styled.div`
  width: 100%;
  max-width: ${props => props.theme.layout.maxWidth};
  padding: 0 ${props => props.theme.layout.paddingInline};
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.xs`
    justify-content: center;
  `}
`;

TopBar.propTypes = {
  children: PropTypes.node,
  background: PropTypes.string,
  fixed: PropTypes.bool,
};
